import $ from 'jquery'
import { toolkitUrls, goalbookUrls } from '@/links'
import { defaultMemoryCache, ajaxCacheWrapper } from './cache'

export {
  shareStrategy,
  unshareStrategy,
  getStrategiesGrouped,
  getStrategy,
  getSharedStrategy,
  getStrategiesForUuids,
  getStrategies,
  getStrategyTags
}

function shareStrategy(uuid) {
  return $.ajax({
    url: `${toolkitUrls.api}//library/strategy/${uuid}/share`,
    method: 'PUT',
    xhrFields: { withCredentials: true }
  })
}

function unshareStrategy(uuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/strategy/${uuid}/unshare`,
    method: 'PUT',
    xhrFields: { withCredentials: true }
  })
}

function getStrategiesGrouped() {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/strategies/grouped`,
    method: 'GET',
    dataType: 'json',
    xhrFields: { withCredentials: true }
  })
}

// ID can be either UUID or Slug
function getStrategy(uuidOrSlug, queryParams = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/strategy/${uuidOrSlug}`,
    method: 'GET',
    dataType: 'json',
    data: $.param(queryParams),
    xhrFields: { withCredentials: true }
  })
}

function getSharedStrategy(uuid, queryParams = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/library/shared/strategy/${uuid}`,
    method: 'GET',
    dataType: 'json',
    data: $.param(queryParams)
  })
}

function getStrategiesForUuids(uuids) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/strategies/uuids`,
    method: 'GET',
    dataType: 'json',
    data: $.param({ list: uuids.join(',') }),
    xhrFields: { withCredentials: true }
  })
}

/* params can contain:
 * tags: a comma-separated list of subject/barriers
 * setting: string
 * teachingType: string
 * grades: comma-separated list of grade levels
 * published: bool
 * less_fields: bool
 */
var _getStrategiesXhr = null
function getStrategies(params = {}) {
  Object.keys(params).forEach(key => {
    if (!params[key]) {
      delete params[key]
    }
  })
  if (_getStrategiesXhr && _getStrategiesXhr.readyState != 4) {
    _getStrategiesXhr.abort()
  }
  _getStrategiesXhr = $.ajax({
    url: `${goalbookUrls.pathwaysApi}/strategies/wizard`,
    method: 'GET',
    dataType: 'json',
    data: $.param(params)
  })
  return _getStrategiesXhr
}

function getStrategyTags(params = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/strategy_tags`,
    method: 'GET',
    dataType: 'json',
    data: $.param(params),
    xhrFields: { withCredentials: true }
  })
}
